const principles = [
  {
    title: 'Intelligence that is Explainable',
    description: 'AI systems that teams can understand, trust, and act upon with confidence'
  },
  {
    title: 'Infrastructure that is Scalable',
    description: 'Production-grade systems built to grow with your business and handle mission-critical workloads'
  },
  {
    title: 'Systems that are Simple to Operate',
    description: 'Intelligent automation that reduces complexity and accelerates decision-making'
  }
];

const WhyNyaxo = () => {
  return (
    <section data-testid="why-nyaxo-section" className="py-24 px-6 bg-[#0D0D0D] relative overflow-hidden">
      {/* Background image */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/1148820/pexels-photo-1148820.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      ></div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 uppercase tracking-wide">
            Our <span className="text-[#00E600]">Philosophy</span>
          </h2>
          <p className="text-[#B3B3B3] text-lg max-w-2xl mx-auto">
            Modern companies generate more data than they can interpret. Nyaxo's mission is to turn that data into action — predictions, alerts, and automated workflows that reduce friction and improve decision-making.
          </p>
        </div>

        {/* Principles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-16">
          {principles.map((principle, index) => (
            <div
              key={index}
              data-testid={`principle-card-${index}`}
              className="bg-[#1A1A1A]/80 backdrop-blur-sm border border-[#2F2F2F] rounded-lg p-6 md:p-8 hover:border-[#00E600] transition-all duration-300 group"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-[#00E600] to-[#36E0A8] rounded-lg flex items-center justify-center group-hover:shadow-[0_0_20px_rgba(0,230,0,0.5)] transition-shadow duration-300">
                  <svg className="w-6 h-6 text-[#0D0D0D]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-2 uppercase tracking-wide">
                    {principle.title}
                  </h3>
                  <p className="text-[#B3B3B3]">
                    {principle.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Visual separator */}
        <div className="flex items-center justify-center my-12">
          <div className="h-px bg-gradient-to-r from-transparent via-[#00E600] to-transparent w-full max-w-md"></div>
        </div>
      </div>
    </section>
  );
};

export default WhyNyaxo;